import React from "react";
import { useGlobalContext } from "../context";
import logo from "../images/logo.svg";
import bars from "../images/icon-hamburger.svg";
import close from "../images/icon-close.svg";

const Navbar = () => {
	const { isToggle, isOpen, togglerHandler } = useGlobalContext();
	return (
		<div className="navbar sticky-navbar">
			<div className="container flex flex-row align-center space-between ">
				{/* logo */}
				<div className="logo">
					<a href="/" aria-label="homepage link">
						<img src={logo} alt="" />
					</a>
				</div>
				{/* toggler */}
				<button onClick={togglerHandler}>
					<img src={isToggle ? close : bars} alt="" />
				</button>
				{/* links */}
				<nav className={`links text-center ${isOpen ? "open" : ""} `}>
					<ul>
						<li>
							<a href="/" aria-label="How We Work link">
								How we work
							</a>
						</li>
						<li>
							<a href="/" aria-label="Blog link">
								Blog
							</a>
						</li>
						<li>
							<a href="/" aria-label="Account link">
								Account
							</a>
						</li>
						<li>
							<a href="/" aria-label="Plans link">
								View plans
							</a>
						</li>
					</ul>
				</nav>
			</div>
		</div>
	);
};

export default Navbar;
